module.exports = __webpack_public_path__ + "static/media/video-plus.da329a81.svg";